<template>
  <div>
    <el-row>
      <el-col :span="5">
        <basic-container>
          <div style="display: flex">
            <!-- <span>项目名称:</span> -->
            <el-form inline>
              <el-form-item>
                <el-row>
                  <el-col :span="7">项目名称</el-col>
                  <el-col :span="17">
                    <el-select
                      v-model="tempProjectId"
                      placeholder="请选择项目名称"
                      @change="changeProject"
                    >
                      <el-option
                        v-for="(item, index) in projectList"
                        :key="index"
                        :label="item.name"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </el-col>
                </el-row>
              </el-form-item>
            </el-form>
          </div>
          <!-- 右键菜单 -->
          <!-- <avue-tree :option="treeOption" :data="treeData" @node-click="nodeClick" @update="treeUpdate"
          @save="saveNode" @del="delNode" v-model="treeForm"/>-->

          <el-tree
            ref="tree"
            :data="treeData"
            node-key="id"
            :expand-on-click-node="false"
            lazy
            :load="treeLoad"
            :props="treeProps"
            :filter-node-method="filterNode"
            @node-click="nodeClick"
          >
            <span slot-scope="{ node }" class="custom-tree-node">
              <span style="flex: 3">
                <el-tooltip class="item" effect="dark" :content="node.label" placement="top-start">
                  <span>
                    {{
                    node.label.length > 5 ? node.label.slice(0, 4) + '...' : node.label
                    }}
                  </span>
                </el-tooltip>
              </span>
              <span style="flex: 1" class="menu">
                <el-tooltip class="item" effect="dark" content="新增子目录" placement="top">
                  <i
                    class="iconfont iconicon_subordinate"
                    @click="addCatalog(node)"
                    v-if="permissionList.addBtn"
                  ></i>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" content="编辑" placement="top">
                  <i
                    class="iconfont iconicon_compile"
                    @click="editCatalog(node)"
                    v-if="permissionList.editBtn"
                  ></i>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" content="删除" placement="top">
                  <i
                    class="iconfont iconicon_delete"
                    @click="delCatalog(node)"
                    v-if="permissionList.delBtn"
                  ></i>
                </el-tooltip>
                <!-- <i class="el-icon-plus"  @click="addCatalog(node)" v-if="permissionList.menuAdd"></i>
              <i class="el-icon-edit"  @click="editCatalog(node)" v-if="permissionList.menuEdit"></i>
                <i class="el-icon-delete" @click="delCatalog(node)" v-if="permissionList.menuDel"></i>-->
                <!-- <el-button type="text" size="small" @click="addCatalog(node)" v-if="permissionList.menuAdd"> 新增子目录 </el-button>
              <el-button type="text" size="small" @click="editCatalog(node)" v-if="permissionList.menuEdit"> 编辑 </el-button>
                <el-button type="text" size="small" @click="delCatalog(node)" v-if="permissionList.menuDel">删除</el-button>-->
              </span>
            </span>
          </el-tree>
        </basic-container>
      </el-col>
      <el-col :span="19">
        <basic-container>
          <avue-crud
            v-if="avueCrudVisible"
            :option="option"
            :table-loading="loading"
            :data="data"
            :page.sync="page"
            :permission="permissionList"
            :before-open="beforeOpen"
            v-model="form"
            ref="crud"
            id="area202112003"
            @row-update="rowUpdate"
            @row-save="rowSave"
            @row-del="rowDel"
            @search-change="searchChange"
            @search-reset="searchReset"
            @selection-change="selectionChange"
            @current-change="currentChange"
            @size-change="sizeChange"
            @on-load="onLoad"
            @refresh-change="onLoad"
          >
            <template slot="menuLeft">
              <el-button type="primary" size="small" @click="qrcodeDownloadDialog">
                <span class="el-icon-printer"></span>
                打 印 标 识 码
              </el-button>
              <el-button type="primary" size="small" @click="viewPrintCollection">
                <span class="el-icon-view"></span>
                查 看 打 印 集
              </el-button>
              <el-button
                type="primary"
                size="small"
                icon="el-icon-top"
                @click="addPrintCollectionList"
              >批量加入打印集</el-button>
            </template>

            <!-- 百度地图获取经纬度以及地址 -->
            <template slot="addrForm">
              <div>
                <el-popover placement="right" width="600" trigger="click">
                  <div>
                    <baiduMapPositon :keyword="form.addr" @map-confirm="getlnglat"></baiduMapPositon>
                  </div>

                  <el-input
                    v-model="form.addr"
                    @focus="dialogBaiduMap = false"
                    slot="reference"
                    placeholder="请输入地址"
                  ></el-input>
                </el-popover>
                <!-- <baidu-map >
                  <bm-local-search
                    :keyword="keyword"
                    :auto-viewport="true"
                    :forceLocal='false'
                    :selectFirstResult='false'
                    :panel="panel"
                    @infohtmlset="infohtmlset"
                  ></bm-local-search>
                </baidu-map>-->
              </div>
            </template>
            <template slot="parentIdForm" slot-scope="scope">
              <el-select
                :value="form.areaName"
                placeholder="请选择存放区域"
                clearable
                style="width: 100%;"
              >
                <el-option :value="form.areaName" show-all-levels :label="form.areaName">
                  <el-tree
                    node-key="id"
                    :data="treeFormAreaData"
                    :props="treeProps"
                    :load="addLazyLoadLeftTree"
                    lazy
                    @node-click="areaNodeTreeClick"
                  ></el-tree>
                </el-option>
              </el-select>
            </template>
            <template slot-scope="{ row }" slot="status">
              <el-tag
                :type="row.status === 1 ? 'success' : 'danger'"
              >{{ row.status === 0 ? '停用' : '正常' }}</el-tag>
            </template>
            <template slot-scope="scope" slot="menu">
              <el-button
                type="text"
                size="small"
                icon="el-icon-circle-plus-outline"
                @click="addPrintCollection(scope.row)"
                style="color: #409EFF"
              >加入打印集</el-button>
            </template>
            <template slot-scope="{ row }" slot="parentId">{{ getAreaName(row.parentId) }}</template>
            >
          </avue-crud>
          <el-dialog
            title="项目地址"
            :modal-append-to-body="false"
            style="z-index:5000"
            :visible.sync="dialogBaiduMap"
          >
            <div style="height:400px">
              <baidu-map class="map" center="北京">
                <bm-geolocation
                  anchor="BMAP_ANCHOR_BOTTOM_RIGHT"
                  :showAddressBar="true"
                  :autoLocation="true"
                ></bm-geolocation>
              </baidu-map>
            </div>
          </el-dialog>
        </basic-container>
      </el-col>
    </el-row>
    <qrcodeDownload ref="qrcodeDownload"></qrcodeDownload>
    <printCollection ref="printCollection"></printCollection>
    <!-- 新增树 -->
    <!-- <el-dialog
      :title="catalogFormTitle"
      v-if="catalogDialogShow"
      :visible.sync="catalogDialogShow"
      width="50%"
      :before-close="handleClose"
      append-to-body
    >
      <el-form ref="form" :model="catalogForm" label-width="80px">
        <el-form-item label="上级目录" v-if="catalogFormTitle == '新增'">
          <el-input v-model="catalogForm.parentName" disabled></el-input>
        </el-form-item>
        <el-form-item
          label="目录名称"
          prop="name"
          :rules="[{ required: true, message: '请输入目录名称', trigger: 'blur' }]"
        >
          <el-input v-model="catalogForm.name" maxlength="30" show-word-limit></el-input>
        </el-form-item>
        <el-form-item
          label="区域编号"
          prop="code"
          :rules="[{ required: true, message: '请输入区域编号', trigger: 'blur' }]"
        >
          <el-input v-model="catalogForm.code" maxlength="30" show-word-limit></el-input>
        </el-form-item>
        <el-form-item
          label="排序"
          prop="sort"
          :rules="[
            { required: true, message: '请输入排序号', trigger: 'blur' },
            { pattern: /^[0-9]*[0-9][0-9]*$/, message: '请输入排序号' },
          ]"
        >
          <el-input v-model="catalogForm.sort" maxlength="8" show-word-limit></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="saveCatalog">提交</el-button>
          <el-button @click="cancelCreateCatalog">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog> -->
    <hr-dialog 
          :title="catalogFormTitle"
          ref="remarkTemp"
          :visible.sync="catalogDialogShow"
          width="50%"
          :handleClose='handleClose'>
          <template
           v-slot:body>
             <el-form ref="form" :model="catalogForm" label-width="80px">
        <el-form-item label="上级目录" v-if="catalogFormTitle == '新增'">
          <el-input v-model="catalogForm.parentName" disabled></el-input>
        </el-form-item>
        <el-form-item
          label="目录名称"
          prop="name"
          :rules="[{ required: true, message: '请输入目录名称', trigger: 'blur' }]"
        >
          <el-input v-model="catalogForm.name" maxlength="30" show-word-limit></el-input>
        </el-form-item>
        <el-form-item
          label="区域编号"
          prop="code"
          :rules="[{ required: true, message: '请输入区域编号', trigger: 'blur' }]"
        >
          <el-input v-model="catalogForm.code" maxlength="30" show-word-limit></el-input>
        </el-form-item>
        <el-form-item
          label="排序"
          prop="sort"
          :rules="[
            { required: true, message: '请输入排序号', trigger: 'blur' },
            { pattern: /^[0-9]*[0-9][0-9]*$/, message: '请输入排序号' },
          ]"
        >
          <el-input v-model="catalogForm.sort" maxlength="8" show-word-limit></el-input>
        </el-form-item>
        <el-form-item style="text-align: right">
          <el-button type="primary" @click="saveCatalog">保存</el-button>
          <el-button @click="cancelCreateCatalog">取消</el-button>
        </el-form-item>
      </el-form>
          </template>
       </hr-dialog>
  </div>
</template>

<script>
import {
  add,
  getDetail,
  getList,
  remove,
  update,
  lazyTreeByProjectId,
  treeByProjectDeptId,
  getAreaNodeByProjectId,
} from '@/api/crmedical/project/area';
import { mapGetters } from 'vuex';
import { getProjectDict } from '@/api/crmedical/project-dictionary/project-dictionary';
import qrcodeDownload from '../device/device/qrcode-download';
import { getProjectList } from '@/api/crmedical/project/project';
import printCollection from '@/views/crmedical/project/areaprintcollection';
import { addPrintCollection } from '@/api/crmedical/project/areaprintcollection';
export default {
  components: {
    qrcodeDownload,
    printCollection,
  },
  data: function() {
    return {
      searchFlag:true,
      catalogFormTitle:'',
      todoListLength: 10000000000000000,
      catalogDialogShow: false, //新增对话框
      form: {},
      query: {},
      loading: true,
      listFlag: false,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      avueCrudVisible: true,
      selectionList: [],
      projectList: [],
      tempProjectId: '',
      treeForm: {},
      areaNodeList: [],
      option: {
        dialogWidth:'65%',
        height: 'auto',
        calcHeight: 100,
        searchMenuSpan: 18,
        tip: false,
        border: true,
        index: true,
        indexLabel: '序号',
        viewBtn: true,
        selection: true,
        columnBtn: true,
        refreshBtn: true,
        menuWidth: 280,
        column: [
          {
            label: '主键',
            prop: 'id',
            editDisplay: false,
            addDisplay: false,
            viewDisplay: false,
            hide: true,
          },
          {
            label: '项目',
            prop: 'projectId',
            type: 'tree',
            disabled: true,
            dicUrl: '/api/v4ward/project/getProjectList',
            props: { label: 'name', value: 'id' },
            hide: true,
            rules: [
              {
                required: true,
                message: '请输入项目',
                trigger: 'change',
              },
            ],
          },
          {
            label: '区域全称',
            prop: 'fullName',
            maxlength: 30,
            showWordLimit: true,
            overHidden: true,
            editDisplay: false,
            addDisplay: false,
          },
          {
            label: '区域名称',
            prop: 'name',
            maxlength: 30,
            showWordLimit: true,
            overHidden: true,
            search: true,
            rules: [
              {
                required: true,
                message: '请输入区域名称',
                trigger: 'blur',
              },
            ],
          },
          {
            label: '区域编号',
            prop: 'code',
            search: true,
            maxlength: 30,
            showWordLimit: true,
            overHidden: true,
            rules: [
              {
                required: true,
                message: '请输入区域编号',
                trigger: 'blur',
              },
            ],
          },
          {
            label: '上级区域',
            prop: 'parentName',
            hide: true,
            disabled: true,
          },
          {
            label: '上级区域',
            prop: 'parentId',
            editDisplay: false,
            addDisplay: false,
            viewDisplay: false,
            hide: true,
            slot: true,
          },
          {
            label: '节点属性',
            prop: 'nodeType',
            type: 'select',
            disabled: true,
            dataType: 'number',
            dicUrl: 'api/blade-system/dict/dictionary?code=area_node_type',
            props: { label: 'dictValue', value: 'dictKey' },
            rules: [
              {
                required: true,
                message: '请选择节点类型',
                trigger: 'blur',
              },
            ],
          },
          {
            label: '科室',
            prop: 'deptId',
            search: true,
            type: 'tree',
            hide: false,
            dicData: [],
            props: { label: 'title', value: 'key' },
            rules: [
              {
                required: true,
                message: '请选择所属机构',
                trigger: 'change',
              },
            ],
          },
          {
            label: '区域类型',
            prop: 'dataType',
            search: true,
            type: 'select',
            dataType: 'string',
            dicData: [],
            props: { label: 'dictValue', value: 'dictKey' },
            rules: [
              {
                required: true,
                message: '请选择区域类型',
                trigger: 'blur',
              },
            ],
          },
          {
            label: '用途类型',
            prop: 'useType',
            type: 'select',
            search: true,
            dataType: 'string',
            dicData: [],
            props: { label: 'dictValue', value: 'dictKey' },
            rules: [
              {
                required: true,
                message: '请选择用途类型',
                trigger: 'blur',
              },
            ],
          },
          // {
          //   label: "区域面积",
          //   prop: "zoneArea",
          //   precision: 2,
          //   maxlength: 8,
          //   showWordLimit: true,
          //   rules: [
          //     { pattern: /^\d+(\.\d{0,2})?$/, message: '请输入正确的数字，最多精确到小数点后2位' },
          //   ]
          // },
          // {
          //   label: "计量面积",
          //   prop: "measureArea",
          //   precision: 2,
          //   maxlength: 8,
          //   showWordLimit: true,
          //   rules: [
          //     { pattern: /^\d+(\.\d{0,2})?$/, message: '请输入正确的数字，最多精确到小数点后2位' },
          //   ]
          // },
          {
            label: '排序',
            prop: 'sort',
            maxlength: 8,
            showWordLimit: true,
            rules: [
              { pattern: /^[0-9]*[0-9][0-9]*$/, message: '请输入自然数' },
              {
                required: true,
                message: '请输入排序号',
                trigger: 'blur',
              },
            ],
          },
          {
            label: '状态',
            prop: 'status',
            type: 'switch',
            slot: true,
            addDisplay: false,
            dataType: 'number',
            dicUrl: 'api/blade-system/dict/dictionary?code=project_status_type',
            props: { label: 'dictValue', value: 'dictKey' },
          },
        ],
      },
      treeOption: {
        nodeKey: 'id',
        addBtn: true,
        editBtn: true,
        delBtn: true,
        menu: true,
        lazy: true,
        // filter: false,
        treeLoad: function(node, resolve) {
          if (node.data.length != 0) {
            lazyTreeByProjectId({ parentId: node.data.id, projectId: node.data.projectId }).then(
              (res) => {
                resolve(res.data);
              }
            );
          }
        },
        formOption: {
          labelWidth: 150,
          column: [
            {
              label: '区域编号',
              prop: 'code',
              search: true,
              maxlength: 30,
              showWordLimit: true,
              overHidden: true,
              rules: [
                {
                  required: true,
                  message: '请输入区域编号',
                  trigger: 'blur',
                },
              ],
            },
            {
              label: '排序',
              prop: 'sort',
              maxlength: 8,
              showWordLimit: true,
              rules: [
                { pattern: /^[0-9]*[0-9][0-9]*$/, message: '请输入自然数' },
                {
                  required: true,
                  message: '请输入排序号',
                  trigger: 'blur',
                },
              ],
            },
          ],
        },
        props: {
          labelText: '区域名称',
          overHidden: true,
          label: 'name',
          value: 'id',
          children: 'children',
        },
      },
      treeData: [],
      // treeProps: {
      // label: 'name',
      // isLeaf: 'isLeaf',
      // },
      throttle: false,
      treeProps: {
        //标题
        label: 'name',
        //值
        value: 'id',
        //子节点
        children: 'zones',
        //是否叶子节点
        isLeaf: 'isLeaf',
        //本节点类型key值
        objectType: 'objectType',
        //本节点类型名
        objectTypeName: 'objectTypeName',
        //节点数据权限
      },
      //选中的树形节点信息
      treeTrackProjectId: '',
      treeTrackNodeType: '',
      treeTrackId: '',
      treeTrackCode: '',
      treeTrackName: '',
      filterText: '',
      leftTreeRoot: {},
      leftTreeResolve: {},
      genderTypeList: [],
      data: [],
      catalogForm: {},
    };
  },
  created() {
    this.option.height = this.bodyHeight - 398 + 78 - 46;
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.area_add, false),
        viewBtn: this.vaildData(this.permission.area_view, false),
        delBtn: this.vaildData(this.permission.area_delete, false),
        editBtn: this.vaildData(this.permission.area_edit, false),

        // menuAdd: this.vaildData(this.permission.knowledgeprojectmenu_add, false),
        // menuEdit: this.vaildData(this.permission.knowledgeprojectmenu_edit, false),
        // menuDel: this.vaildData(this.permission.knowledgeprojectmenu_delete, false),
        // recommend: this.vaildData(this.permission.knowledgeprojectfile_recommend, false),
      };
    },
    ids() {
      let ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
  },
  mounted() {
    document.querySelectorAll('.basic-container')[2].querySelector('.el-card__body').style.setProperty('padding','0','important')
    this.initAllStatusList();
    console.log(this.$refs.crud.$children);
    console.log(this.page);

    this.$nextTick(() => {
      setTimeout(() => {
        this.$refs.crud.$children[1].$children[6].$el.addEventListener('click', () => {
          // console.log('dd=======================================>');
          if (this.todoListLength == 0) {
            
          } else {
            if (this.option.height == this.bodyHeight - 398 + 78 - 46) {
              this.option.height = this.bodyHeight - 287 + 78 - 46;
            } else {
              this.option.height = this.bodyHeight - 398 + 78 - 46;
            }
            this.$refs.crud.getTableHeight();
          }
        });
      });
    });
  },

  methods: {
    //取消
    

    cancelCreateCatalog() {
      this.catalogDialogShow = false;
    },
    //删除菜单
    delCatalog(node) {
      if (node.data.id === '0') {
        this.$message.warning('最顶级区域不允许删除!');
        return;
      }
      this.$confirm('此操作将删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          if (node.data.hasChildren) {
            this.$message.error('请先删除该区域下的子区域或子节点!');
          } else {
            return remove({ ids: node.data.id }).then(() => {
              this.$message.success('操作成功!');
            });
          }
        })
        .then(() => {
          this.initData(this.tempProjectId);
          this.treeForm = {};
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          });
        });
    },
    // 编辑菜单
    editCatalog(node) {
      if (node.data.id === '0') {
        this.$message.warning('最顶级区域不允许修改!');
        this.initData(this.tempProjectId);
        return;
      }
      console.log('node==>', node);
      this.catalogFormTitle = '编辑';
      this.catalogForm = {
        id: node.data.id,
        name: node.data.name,
        code: node.data.code,
        sort: node.data.sort,
        parentId: node.data.parentId,
        projectId: this.tempProjectId,
      };
      this.catalogForm.status = '';
      this.catalogForm.updateTime = '';
      this.catalogForm.updateUser = '';
      this.catalogForm.createDept = '';
      this.catalogForm.createUser = '';
      this.catalogForm.isDeleted = '';
      this.catalogDialogShow = true;
    },
    //新增菜单
    addCatalog(node) {
      this.catalogForm = {
        parentId: node ? node.data.id : 0,
        parentName: node ? node.data.name : '',
        projectId: this.tempProjectId,
      };
      this.catalogForm.nodeType = 1;
      this.catalogFormTitle = '新增';
      this.catalogDialogShow = true;
    },
    saveCatalog() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          if (this.throttle) return;
          this.throttle = true;
          let api = this.catalogForm.id ? update : add;
          api(this.catalogForm)
            .then(() => {
              this.throttle = false;
              this.initData(this.tempProjectId);
              // this.initData();
              this.$message.success('操作成功!');
              this.catalogDialogShow = false;
            })
            .catch(() => {
              this.catalogDialogShow = false;
              this.throttle = false;
            });
        } else {
          return;
        }
      });
    },
    treeLoad: function(node, resolve) {
      if (node.data.length != 0) {
        lazyTreeByProjectId({ parentId: node.data.id, projectId: node.data.projectId }).then(
          (res) => {
            resolve(res.data);
          }
        );
      }
    },
    saveNode(data, parent, done, loading) {
      if (parent.name.length > 30) {
        this.$message.warning('区域名称超出30字符长度!');
        // this.form.projectId = this.projectIdList[0].id;
        this.initData(this.form.projectId);
        // done();
        setTimeout(() => {
          // this.$message.success('关闭按钮等待');
          loading();
        }, 100);
        return;
      }
      this.treeForm.id = '';
      this.treeForm.projectId = this.tempProjectId;
      this.treeForm.name = parent.name;
      this.treeForm.code = parent.code;
      this.treeForm.sort = parent.sort;
      this.treeForm.nodeType = 1;
      if (data.id) {
        this.treeForm.parentId = data.id;
      } else {
        this.treeForm.parentId = 0;
      }
      add(this.treeForm).then(
        () => {
          // this.form.projectId = this.projectIdList[0].id;
          this.initData(this.tempProjectId);
          // this.initData();
          this.$message.success('操作成功!');
          done();
        },
        (error) => {
          window.console.log(error);
          loading();
        }
      );
      this.treeForm = {};
    },
    treeUpdate(data, parent, done, loading) {
      if (parent.name.length > 30) {
        this.$message.warning('区域名称超出30字符长度!');
        done();
        this.initData(this.tempProjectId);
        return;
      }
      if (data.id === '0') {
        this.$message.warning('最顶级区域不允许修改!');
        done();
        this.initData(this.tempProjectId);
        return;
      }
      this.treeForm.id = data.id;
      this.treeForm.code = parent.code;
      this.treeForm.name = parent.name;
      this.treeForm.sort = parent.sort;
      this.treeForm.status = '';
      this.treeForm.updateTime = '';
      this.treeForm.updateUser = '';
      this.treeForm.createDept = '';
      this.treeForm.createUser = '';
      this.treeForm.isDeleted = '';
      update(this.treeForm).then(
        () => {
          this.initData(this.tempProjectId);
          this.$message.success('操作成功!');
          this.onLoad();
          done();
        },
        (error) => {
          window.console.log(error);
          loading();
        }
      );
      this.treeForm = {};
    },
    delNode(data, done) {
      if (data.id === '0') {
        this.$message.warning('最顶级区域不允许删除!');
        done();
        return;
      }
      this.$confirm('此操作将删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          if (data.hasChildren) {
            this.$message.error('请先删除该区域下的子区域或子节点!');
          } else {
            return remove({ ids: data.id }).then(() => {
              this.$message.success('操作成功!');
            });
          }
        })
        .then(() => {
          this.initData(this.tempProjectId);
          this.treeForm = {};
          done();
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          });
        });
    },
    changeProject() {
      this.initData(this.tempProjectId);
      getAreaNodeByProjectId({ projectId: this.tempProjectId }).then((res) => {
        this.areaNodeList = res.data;
      });
      this.treeTrackId = '';
      this.data = [];
    },
    //树形菜单目录
    initData(projectId) {
      lazyTreeByProjectId({ parentId: 0, projectId: projectId, topFlag: 0 }).then((res) => {
        this.treeData = res.data;
      });
    },
    initAllStatusList() {
      //加载列表
      getProjectList({}).then((res) => {
        this.projectList = res.data;
        if (this.projectList.length > 0) {
          this.tempProjectId = this.projectList[0].id;
          this.initData(this.tempProjectId);
          getAreaNodeByProjectId({ projectId: this.tempProjectId }).then((res) => {
            this.areaNodeList = res.data;
          });
        }
      });
    },
    getAreaName(areaId) {
      let areaName = '';
      this.areaNodeList.forEach(function(value) {
        if (value.id === areaId) {
          areaName = value.name;
          return;
        }
      });
      return areaName;
    },
    // 打开二维码查看弹窗
    qrcodeDownloadDialog() {
      if (!this.tempProjectId) {
        this.$message({
          message: '请先选择项目',
          type: 'warning',
        });
        return;
      }
      if (this.selectionList.length == 0) {
        this.$message({
          message: '请选择区域',
          type: 'warning',
        });
        return;
      }
      this.$refs.qrcodeDownload.getQrcodes(this.tempProjectId, 1, this.selectionList);
    },

    viewPrintCollection() {
      if (!this.tempProjectId) {
        this.$message({
          message: '请先选择项目',
          type: 'warning',
        });
        return;
      }
      this.listFlag = true;
      this.$refs.printCollection.openAreaPrintCollectionOnload(this.tempProjectId);
    },
    addPrintCollectionList(row) {
      console.log(row);
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据');
        return;
      }
      this.$confirm('确定将所选区域加入打印集', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return addPrintCollection({ areaIds: this.ids, projectId: this.tempProjectId });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
          this.$refs.crud.toggleSelection();
        });
    },
    addPrintCollection(row) {
      this.$confirm('确定将所选区域加入打印集', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return addPrintCollection({ areaIds: row.id, projectId: this.tempProjectId });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
          this.$refs.crud.toggleSelection();
        });
    },

    avueCrudView() {
      this.avueCrudVisible = false;
      setTimeout(() => {
        this.avueCrudVisible = true;
      }, 100);
    },
    //树节点过滤
    filterNode(value, data) {
      if (!value) return true;
      return data[this.treeProps.label].indexOf(value) !== -1;
    },
    nodeClick(data) {
      this.data = [];
      this.query = {};
      this.treeTrackProjectId = data.projectId;
      this.treeTrackNodeType = data.nodeType;
      this.treeTrackId = data.id;
      this.treeTrackCode = data.code;
      this.treeTrackName = data.name;
      treeByProjectDeptId({ projectId: data.projectId }).then(({ data }) => {
        this.findObject(this.option.column, 'deptId').dicData = data;
      });
      getProjectDict({ projectId: data.projectId, code: 'project_area_data_type' }).then(
        ({ data }) => {
          const dataType = this.findObject(this.option.column, 'dataType');
          dataType.dicData = data;
        }
      );
      getProjectDict({ projectId: data.projectId, code: 'project_area_use_type' }).then(
        ({ data }) => {
          const useType = this.findObject(this.option.column, 'useType');
          useType.dicData = data;
        }
      );
      this.avueCrudView();
    },

    rowSave(row, loading, done) {
      row.parentId = this.treeTrackId;
      add(row).then(
        () => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    rowUpdate(row, index, loading, done) {
      update(row).then(
        () => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    rowDel(row) {
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: row.id });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
        });
    },
    handleDelete: function() {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据');
        return;
      }
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: this.ids });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
          this.$refs.crud.toggleSelection();
        });
    },
    beforeOpen(done, type) {
      console.log(this.$refs.crud.$children[4].$children[0]);
      this.$refs.crud.$children[4].$children[0].appendToBody = false;
      this.$refs.crud.$children[4].$children[0].beforeClose = false 
      if (['edit', 'view'].includes(type)) {
        getDetail({ id: this.form.id }).then(({ data }) => {
          this.form = data;
          getDetail({ id: this.form.parentId }).then(({ data }) => {
            this.form.parentName = data.name;
          });
        });
        if (['view'].includes(type)) {
          setTimeout(() => {
            getProjectDict({
              projectId: this.treeTrackProjectId,
              code: 'project_area_data_type',
            }).then(({ data }) => {
              const dataType = this.findObject(this.option.column, 'dataType');
              dataType.dicData = data;
              let tempInputValue = document.querySelector(
                'div[id*=el-collapse-content] > div > div > div:nth-child(8) > div > div > div > div > input'
              ).value;
              dataType.dicData.forEach((e) => {
                console.log(e);
                if (e.dictKey === tempInputValue) {
                  document.querySelector(
                    'div[id*=el-collapse-content] > div > div > div:nth-child(8) > div > div > div > div > input'
                  ).value = e.dictValue;
                }
              });
            });
            getProjectDict({
              projectId: this.treeTrackProjectId,
              code: 'project_area_use_type',
            }).then(({ data }) => {
              const useType = this.findObject(this.option.column, 'useType');
              useType.dicData = data;

              let tempInputValue = document.querySelector(
                'div[id*=el-collapse-content] > div > div > div:nth-child(9) > div > div > div > div > input'
              ).value;
              useType.dicData.forEach((e) => {
                console.log(e);
                if (e.dictKey === tempInputValue) {
                  document.querySelector(
                    'div[id*=el-collapse-content] > div > div > div:nth-child(9) > div > div > div > div > input'
                  ).value = e.dictValue;
                }
              });
            });
          }, 0);
        }
        if (['edit'].includes(type)) {
          setTimeout(() => {
            getProjectDict({
              projectId: this.treeTrackProjectId,
              code: 'project_area_data_type',
            }).then(({ data }) => {
              const dataType = this.findObject(this.option.column, 'dataType');
              dataType.dicData = data;
              let tempInputValue = document.querySelector(
                'div[id*=el-collapse-content] > div > div > div:nth-child(7) > div > div > div > div > input'
              ).value;
              dataType.dicData.forEach((e) => {
                console.log(e);
                if (e.dictKey === tempInputValue) {
                  document.querySelector(
                    'div[id*=el-collapse-content] > div > div > div:nth-child(7) > div > div > div > div > input'
                  ).value = e.dictValue;
                }
              });
            });
            getProjectDict({
              projectId: this.treeTrackProjectId,
              code: 'project_area_use_type',
            }).then(({ data }) => {
              const useType = this.findObject(this.option.column, 'useType');
              useType.dicData = data;

              let tempInputValue = document.querySelector(
                'div[id*=el-collapse-content] > div > div > div:nth-child(8) > div > div > div > div > input'
              ).value;
              useType.dicData.forEach((e) => {
                console.log(e);
                if (e.dictKey === tempInputValue) {
                  document.querySelector(
                    'div[id*=el-collapse-content] > div > div > div:nth-child(8) > div > div > div > div > input'
                  ).value = e.dictValue;
                }
              });
            });
          }, 0);
        }
      } else {
        if (this.treeTrackId === '0') {
          this.$message.warning('最顶级区域不允许新增子节点!');
          return;
        }
        if (!this.treeTrackId) {
          this.$message.error('请先选择左侧区域!');
          return;
        }
        //新增逻辑
        //一定要用setTimeout包裹，由于form组件底层一些机制的设计
        setTimeout(() => {
          this.form.projectId = this.tempProjectId;
          this.form.nodeType = 2;
          this.form.parentId = this.treeTrackId;
          this.form.parentName = this.treeTrackName;
        }, 0);
      }
      done();
    },
    searchReset() {
      this.query = {};
      this.onLoad();
    },
    searchChange(params, done) {
      this.query = params;
      this.page.currentPage = 1;
      this.onLoad();

      done();
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    onLoad(page) {
                // document.querySelectorAll('.basic-container')[2].querySelector('.el-card__body').className=''
              
      page = page || this.page;
      this.loading = true;
      if (this.treeTrackId) {
        this.query.parentId = this.treeTrackId;
        this.query.projectId = this.tempProjectId;
        getList(Object.assign({ current: page.currentPage, size: page.pageSize }, this.query)).then(
          ({ data }) => {
            
          // console.log(this.$refs.crud.$children[1].$children[6].$el.disabled,this.$refs.crud.$children[1].$children[6].$el);
            this.todoListLength = data.records.length;
            //  this.option.height = this.bodyHeight - 398;
            //  this.$refs.crud.getTableHeight();

            // console.log(data.records.length);
            if(this.searchFlag){
                if (data.records.length === 0) {
                  this.option.height = this.bodyHeight - 398 + (78 - 46);
                } else {
                  this.option.height = this.bodyHeight - 398;
                }
                this.$refs.crud.getTableHeight();
            }
            console.log(this.$refs.crud,this.option.height);

            this.page.total = data.total;
            this.data = data.records;
            this.loading = false;
            this.selectionClear();
            //重新绑定在放大镜上的改变高度的方法
              this.$nextTick(() => {
                    setTimeout(() => {
                      this.$refs.crud.$children[1].$children[6].$el.onclick= () => {
                        this.searchFlag = !this.searchFlag
                        console.log(this.searchFlag);
                        if (this.todoListLength == 0) {
                          if (this.option.height == this.bodyHeight - 398+32 ) {
                            this.option.height = this.bodyHeight - 287+32;
                          } else {
                            this.option.height = this.bodyHeight - 398+32;
                          }
                          // console.log('1283======================>',this.option.height);
                          this.$refs.crud.getTableHeight();
                        } else {
                          //398是默认高度  78-46是分页所占的高度
                          if (this.option.height == this.bodyHeight - 398 ) {
                            this.option.height = this.bodyHeight - 287;
                          } else {
                            this.option.height = this.bodyHeight - 398;
                          }
                          this.$refs.crud.getTableHeight();
                         
                          // console.log('更新完高度之后的方法=====================>',this.option.height, this.bodyHeight);
                        }
                      };
                    });
                  });
          }
        );
        
      } else {
        this.loading = false;
        this.selectionClear();
      }
      
    },
  },
};
</script>

<style lang="scss" scoped>
//  .item {
//       margin: 4px;
//     }
::v-deep .custom-tree-node {
  position: relative;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 12px;
  .menu {
    width: 40%;
    position: absolute;
    right: 0;
    // background: white;
    opacity: 1;
    display: flex;
    justify-content: space-between;
  }
  ::v-deep .avue-form__menu--center {
    text-align: right;
  }
  ::v-deep .avue-crud__search .el-form-item--small.el-form-item {
    width: 100%;
  }
}
</style>
<style>
/* #avue-view > div > div.basic-container > div > div{
    height: 0;
    padding: 0 !important;
  } */

#area202112003 .avue-form__menu {
  text-align: right;
  padding-right: 5px !important;
}
  #area202112003 .el-card__body {
    height: 0;
    padding: 0 !important;
  }
</style>
